import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { SupportDataService } from './support-data.service';
import { Support } from './models/support.model';
import {
  fetchSupportError,
  FetchSupportSuccess,
  FetchSupportError,
  fetchSupportSuccess,
  ActionsEnum,
} from './support-data.actions';

@Injectable()
export class SupportDataEffects {
  constructor(
    private _actions: Actions,
    private _supportDataService: SupportDataService
  ) {}

  @Effect()
  fetchSupport: Observable<
    FetchSupportSuccess | FetchSupportError
  > = this._actions.pipe(
    ofType(ActionsEnum.FETCH_SUPPORT),
    switchMap(() => {
      return this._supportDataService.fetchSupport().pipe(
        map((support: Support) => fetchSupportSuccess(support)),
        catchError((error) => of(fetchSupportError(error)))
      );
    })
  );
}
